import React from 'react';
import styles from './StickyNavbar.module.scss';

interface StickyNavbarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  logo: string;
}

const StickyNavbar: React.FC<StickyNavbarProps> = ({ 
  activeTab, 
  onTabChange, 
  logo 
}) => {
  const handleTabClick = (tab: string) => {
    onTabChange(tab);
  };

  return (
    <nav className={styles.stickyNavbar}>
      <div className={styles.stickyNavbar_content}>
        <div className={styles.stickyNavbar_logoContainer}>
          <img 
            src={logo || "/placeholder.svg"} 
            alt="Logo de Edify" 
            className={styles.stickyNavbar_logo} 
          />
        </div>
        
        <div className={styles.stickyNavbar_tabs}>
          <button
            className={`${styles.stickyNavbar_tab} ${activeTab === "form" ? styles.active : ""}`}
            onClick={() => handleTabClick("form")}
          >
            Inscribirme
          </button>
          <button
            className={`${styles.stickyNavbar_tab} ${activeTab === "offers" ? styles.active : ""}`}
            onClick={() => handleTabClick("offers")}
          >
            Ver Ofertas
          </button>
        </div>
      </div>
    </nav>
  );
};

export default StickyNavbar;
